export default __webpack_public_path__ + "static/media/david_lam.9d4e20b0.jpg";